module.exports = __webpack_public_path__ + "assets/img/91.05f67a66.png";